import React from 'react';
import PropTypes from 'prop-types';

import { amount as amountPropType } from 'common/propTypes';
import colors from 'common/styles/colors';
import Text from 'common/components/Text';

import styles from './index.module.css';
import { TradedAmountUI } from '../OffRampsTable/TradedAmount';

const AmountStrip = ({
  heading,
  amount,
  cryptoAmount,
  color,
  background,
  id,
}) => (
  <div
    className={styles.root}
    style={{ background: colors[background], color: colors[color] }}
    id={id}
  >
    <Text size="caption" color={color}>
      {heading}
    </Text>
    <span className={styles.value}>
      {amount.value} {amount.currency}
    </span>
    {cryptoAmount && (
      <TradedAmountUI
        currency={cryptoAmount.currency}
        value={cryptoAmount.value}
      />
    )}
  </div>
);

AmountStrip.propTypes = {
  heading: PropTypes.string,
  amount: amountPropType.isRequired,
  cryptoAmount: amountPropType,
  color: PropTypes.oneOf(Object.keys(colors)),
  background: PropTypes.oneOf(Object.keys(colors)),
  id: PropTypes.string,
};

AmountStrip.defaultProps = {
  heading: 'Total',
  color: 'rebranding-md-color-brand-black',
  background: 'color-white',
  id: null,
};

export default AmountStrip;
